// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Banner_bannerWrapper__tx8NT"};